import { createContext } from "react";

export const urlContext = createContext();